import { useState } from 'react';
import styled from 'styled-components';
import {
  Breadcrumbs,
  Flex,
  FlexColumn,
  FloatingActionsMenu,
  LineageGraph,
} from '@elementary/common-ui/components';
import { useBreadcrumbs } from '@elementary/common-ui/hooks/useBreadcrumbs';
import type { DagDepthBoundary } from '@elementary/common-ui/components/lineageGraph/types';
import { radius, space } from '@elementary/common-ui/style/utils';
import LineageFilters from './components/LineageFilters';

const TOP_OVERLAY_MARGIN_RIGHT = '100px';

// Leaves room on the right for the graph controls panel.
const TopOverlay = styled(FlexColumn)`
  position: absolute;
  top: 24px;
  left: 24px;
  margin-right: ${TOP_OVERLAY_MARGIN_RIGHT};
  align-items: flex-start;
  gap: ${space('md')};
  z-index: 1;
  pointer-events: none;

  & > * {
    pointer-events: auto;
  }
`;

const BreadcrumbsContainer = styled(Flex)`
  background: ${({ theme }) => theme.palette.surface.base};
  border: ${({ theme }) => `1px solid ${theme.palette.border.light}`};
  border-radius: ${radius('lg')};
  padding: ${space('sm')};
  padding-right: ${space('mdPlus')};
`;

const LineagePage = () => {
  const breadcrumbs = useBreadcrumbs({
    pageTitle: 'Lineage',
  });

  const [dagDepthBoundary, setDagDepthBoundary] = useState<DagDepthBoundary>();

  return (
    <FlexColumn
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <TopOverlay>
        <BreadcrumbsContainer>
          <Breadcrumbs items={breadcrumbs} />
        </BreadcrumbsContainer>
        <LineageFilters dagDepthBoundary={dagDepthBoundary} />
      </TopOverlay>

      <LineageGraph onDagDepthBoundaryChange={setDagDepthBoundary} />
      <FloatingActionsMenu />
    </FlexColumn>
  );
};

export default LineagePage;
